import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { SIGNPORT_URL } from '../lib/signport';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 10/09 (Josh: "need to keep it password protected too, based on login"). Rendered inside ProtectedRoute, so a
// visitor without a PFS session is sent to /login?next=/signport first and lands here after signing in.
// With SIGNPORT_SSO_SECRET set on the API, the app fetches a 5-minute signed token and hands it to Signport's
// /sso endpoint (Signport verifies it and opens its own session). Without the secret: plain redirect.
const SignportGate = () => {
  const { getAuthHeaders } = useAuth();
  const [err, setErr] = useState('');
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/signport/sso-token`, { headers: getAuthHeaders() });
        if (cancelled) return;
        const d = res.data || {};
        window.location.replace(d.configured && d.sso_url ? d.sso_url : (d.url || SIGNPORT_URL));
      } catch (e) {
        if (cancelled) return;
        if (e.response?.status === 403) { setErr('Your login is not allowed to open Signport.'); return; }
        window.location.replace(SIGNPORT_URL);
      }
    })();
    return () => { cancelled = true; };
  }, [getAuthHeaders]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0D1B2A] text-slate-200" data-testid="signport-gate">
      <div className="text-center">
        {err ? (
          <div className="text-sm text-red-300">{err}</div>
        ) : (
          <>
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mb-4" />
            <div className="text-sm">Opening Signport…</div>
            <a href={SIGNPORT_URL} className="text-xs text-blue-400 underline mt-2 inline-block">Continue if nothing happens</a>
          </>
        )}
      </div>
    </div>
  );
};

export default SignportGate;
